<template>
    <po-status-badge :value="value.status" :error="error" :success="success" :warning="warning" />
</template>

<script>

import { User, UserStatusEnum } from '@/model/identity'

export default {
  props: {
    value: User
  },
  computed: {
    error: () => UserStatusEnum.values.INACTIVE,
    success: () => UserStatusEnum.values.ACTIVE,
    warning: () => UserStatusEnum.values.UNVERIFIED
  }
}
</script>
